import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { DEFAULT_MOOD } from './moods';

const MoodContext = createContext({ mood: DEFAULT_MOOD, setMood: () => {} });

export const MoodProvider = ({ children }) => {
  const [mood, setMoodState] = useState(DEFAULT_MOOD);

  const setMood = useCallback((next) => {
    setMoodState(next || DEFAULT_MOOD);
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute('data-mood', mood);
  }, [mood]);

  return (
    <MoodContext.Provider value={{ mood, setMood }}>
      {children}
    </MoodContext.Provider>
  );
};

export const useMoodValue = () => useContext(MoodContext).mood;

/**
 * Claim a mood for as long as the calling component is mounted.
 * Falls back to the neutral mood on unmount so pages without an identity
 * (cabinet, settings, about, contact, product) stay near-black.
 */
export const useMood = (mood) => {
  const { setMood } = useContext(MoodContext);

  useEffect(() => {
    setMood(mood);
    return () => setMood(DEFAULT_MOOD);
  }, [mood, setMood]);
};

export default MoodContext;
